import { IconWrapper } from '../runtime';
export default IconWrapper('ebooks_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#00A692"
    }
  }), h("path", {
    "attrs": {
      "d": "M2 16C0.895431 16 0 15.1046 0 14L16 14C16 15.1046 15.1046 16 14 16L2 16Z",
      "fill": "#009080"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 16L8 14L16 14C16 15.1046 15.1046 16 14 16L8 16Z",
      "fill": "#0BBEA8"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7.25 4.57896C6.68408 4.33465 6.36247 4.23407 5.74951 4.23407H5.74434C5.12153 4.23061 4.5 4.59924 4.5 4.59924L4.50147 9.19813C4.50147 9.19813 5.22007 9.01518 5.75 9.01733C6.30328 9.01424 6.63103 9.09493 7.25 9.29733V9.30006V4.57896ZM8.75 9.30023V4.57881C9.31242 4.33608 9.63879 4.23407 10.2487 4.23408L10.2539 4.23406C10.8767 4.23059 11.4983 4.59926 11.4983 4.59926L11.5 9.19808C11.5 9.19808 10.7798 9.01518 10.25 9.01733C9.69672 9.01424 9.36897 9.09493 8.75 9.29733V9.30023ZM8.45535 10.8401C8.23189 10.9247 8.00084 11.0173 8.00084 11.0173C8.00084 11.0173 7.76974 10.9247 7.54626 10.84C7.43589 10.7982 7.32738 10.7583 7.24948 10.7325C6.76483 10.574 5.90461 10.495 5.39651 10.4984C4.87397 10.4957 4.34091 10.5952 3.91078 10.7063C3.37701 10.8441 3.00173 10.9997 3.00173 10.9997C3.00138 8.59405 3 5.90514 3 3.49949C3.14217 3.39293 3.28407 3.297 3.44342 3.22052C3.60599 3.14283 3.77293 3.0754 3.94333 3.0186C4.52746 2.82672 5.13686 2.73075 5.74951 2.73416C6.51188 2.73416 7.12677 2.87482 7.55519 3.0186C7.70599 3.06886 7.85417 3.12725 7.99911 3.19353C8.14406 3.12725 8.29223 3.06886 8.44303 3.0186C8.87146 2.87482 9.48635 2.73416 10.2487 2.73416C10.8614 2.73075 11.4708 2.82672 12.0549 3.0186C12.2253 3.0754 12.3922 3.14283 12.5548 3.22052C12.7142 3.297 12.8561 3.39293 12.9982 3.49949C12.9982 5.90514 13.0003 8.59405 13 10.9997C13 10.9997 12.6247 10.8441 12.0909 10.7063C11.6608 10.5952 11.1277 10.4957 10.6052 10.4984C10.0971 10.495 9.23685 10.574 8.75221 10.7325C8.67429 10.7583 8.56575 10.7982 8.45535 10.8401Z",
      "fill": "white"
    }
  })]);
});